import React from 'react';
export const domainName = document._portalConfig.customer;

export const connection = {
    cookiesConfig : {
        secure: false,
        expires: 0
    },
    crmConfig: {
        crmServer: document._portalConfig.crmServer,
        crmApiKey: document._portalConfig.publicApiKey,
        applicationID: document._portalConfig.applicationID,
        useCname: document._portalConfig.useCname,
        cname:document._portalConfig.cname
    },
    middlewareConfig:{
        mwServer: "",
        mwApiKey: "",
    },
    middlewareEnable: false,
    sslCertificates: ["crm"],
    enableSSL: false
};
export const portal_config = {
    apiKey:'AIzaSyASJk1hzLv6Xoj0fRsYnfuO6ptOXu0fZsc',
    copyright: '© CRM.COM',
    default_country: "CYP",
    default_language: "EN",
    default_list_language: [
        {
            value: 'EN',
            label: 'English',
            trans_label: 'english',
        },
        {
            value: 'EL',
            label: 'Greek',
            trans_label: 'greek',
        },
    ],
    offer_filter: {
        industry: true,
        industrySector: true,
        tag: true,
        town_city: true,
    },
    default_currency: '€',
    isOrderWithFilterMerchant: false,
    isDisableRegisterExisingCustomer: false,
    isDisableRegister: false,
    isCustomSizeLogoLandingPage: false,
    logoLandingPageSize: {
        width: 100,
        height: 100
    },
    showCardReward: false,
    limitAllowCards: 10,
    showRegisterPromoCode: false,
    showUploadFileSR: true,
    isShowSettingTopup: false
}